import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const ButtonLink = styled(Link)((theme) => ({
  textDecoration: 'unset',
  '&:visited': {
    color: 'inherit',
  },
  ...theme.style,
}))
